import React from 'react';
import styled from 'styled-components';

const ProgressBar = ({ value, max }) => {
    
  const percentage = (value / max) * 100;

    return (
        <BarContainer>
            <BarFill style={{ width: `${percentage}%` }} />
            <PercentageLabel>{percentage.toFixed(2)}%</PercentageLabel>
        </BarContainer>
    );
};

export default ProgressBar;

const BarContainer = styled.div`
    position: relative;
    width: 100%;
    height: 20px;
    background-color: #e0e0de;
    border-radius: 50px;
    margin: 10px 0;
`;

const BarFill = styled.div`
    height: 100%;
    background-color: #76c7c0;
    border-radius: 50px;
    transition: width 0.5s ease-in-out;
`;

const PercentageLabel = styled.span`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    color: #000;
`;